export const data: string[] = [
    "ABOGADOS",
    "AMPROSA",
    "AMSTERDAM SALUD",
    "APROSS",
    "ASOCIART SA ART",
    "ASPURC",
    "ATSA - OSPSA",
    "AVALIAN",
    "BERKLEY ART",
    "CAJA NOTARIAL",
    "CARMED",
    "CIENCIAS ECONOMICAS",
    "ENDOCTER - ENSALUD",
    "ENSALUD",
    "EXPERTA ART (EX QBE)",
    "FEDERADA SALUD",
    "FUTBOLISTAS AGREMIADOS",
    "GALENO - AZUL Y BLANCO",
    "GALENO - ORO Y PLATA",
    "GENMED MEDICAL ASISTANCE",
    "GRAFICOS",
    "IOSFA - DIBA",
    "ISSPICA",
    "JERARQUICO SALUD",
    "LA SEGUNDA ART",
    "LABOUMED SRL",
    "LUIS PASTEURS",
    "LUZ Y FUERZA (AESA) ALUMBRAR",
    "LUZ Y FUERZA REGIONAL SALUD",
    "MADEREROS",
    "MEDICUS - AZUL - BLANCO - CELESTE",
    "MEDICUS - CORP - FAMILY - MC",
    "MEDINALS - PREMED",
    "MUNICIPALES",
    "MUTUAL MEDICA",
    "NOBIS",
    "OMINT SA",
    "OPDEA",
    "OSADEF (EMPLEADOS DE FARMACIA)",
    "OSAM - MINEROS",
    "OSAPM (PROPAGANDA MEDICA)",
    "OSDE",
    "OSDOP - SERVIRED",
    "OSFATLYF RIO CUARTO",
    "OSFATLYF VILLA MARIA",
    "OSFATUN NO DOCENTE",
    "OSOETSYLRA - TINTOREROS (ENSALUD)",
    "OSPACA",
    "OSPCRA (ENSALUD)",
    "OSPECOR",
    "OSPEDYC",
    "OSPEP (PANADEROS)",
    "OSPERHYRA",
    "OSPES (ESTACIONES DE SERVICIO)",
    "OSPIHMP (HIELO) ENSALUD",
    "OSPIM (ENSALUD)",
    "OSSACRA",
    "OSTEL - ACTIVOS - ENSALUD",
    "OSTEL - JUBILADOS - ENSALUD",
    "PARQUE SALUD",
    "PASTELEROS (OPCPHYA)",
    "PODER JUDICIAL",
    "POLICIA FEDERAL",
    "PRENSA",
    "PREVENCION SALUD",
    "PRIVEL OBRA SOCIAL",
    "PRIVEL SERVICIOS SOCIALES",
    "SADAIC",
    "SAN PEDRO",
    "SANCOR SALUD",
    "SAT (TV SALUD)",
    "SEGUROS",
    "SERVIRED (OSBLYCA)",
    "SWISS MEDICAL",
    "UNIMED",
    "UTA",
];
